
export default {
  name: 'InfoPanel',
  props: {
    info: {
      type: Object,
    }
  },
  setup(): Record<string, unknown> {
    // Record<string, unknown>
    // const score = new Score();
    // const info = reactive({
    //   score: infoPanel.gameScore,
    //   level: infoPanel.gameLevel,
    // });
    // const info = reactive(score.info);

    return {}
  }
}
